"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var KnowledgeBaseOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_KnowledgeBaseOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.068 16H3.577a.617.617 0 0 1-.616-.565l-.348-4.162a6.613 6.613 0 0 0-.68-2.416l-.415-.825A4.87 4.87 0 0 1 1 5.847C1 2.617 3.628 0 6.87 0h.281c2.865 0 5.35 1.97 5.994 4.749l.277 1.193c.084.365.27.698.535.963l.644.64c.691.689.45 1.857-.458 2.219l-.485.193a.17.17 0 0 0-.107.158v2.21c0 .893-.78 1.589-1.672 1.49l-.766-.085a1.527 1.527 0 0 0-1.67 1.814.382.382 0 0 1-.375.456Zm2.156-3.264A2.534 2.534 0 0 0 8.42 15H3.932l-.319-3.81a7.61 7.61 0 0 0-.782-2.78l-.415-.826a3.88 3.88 0 0 1-.041-.084H5.5v3.585a1.5 1.5 0 1 0 1 0V7.5a1 1 0 0 0-1-1H2.06a3.87 3.87 0 0 1-.056-.653c0-2.381 1.724-4.361 3.996-4.77v1.008a1.5 1.5 0 1 0 1 0V1h.151a5.146 5.146 0 0 1 4.882 3.5H11a1 1 0 0 0-1 1v1.585a1.5 1.5 0 1 0 1 0V5.5h1.289l.155.667c.126.547.405 1.048.803 1.445l.644.64a.356.356 0 0 1-.12.584l-.486.193a1.17 1.17 0 0 0-.738 1.086v2.21c0 .297-.26.529-.558.496l-.765-.085ZM6 3.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM6 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm4-4.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_KnowledgeBaseOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = KnowledgeBaseOutline;
exports["default"] = _default;